<script>

    import Swal from "sweetalert2";
    import Statistics from "@/services/Statistics";

    export default {
        components:{    },
        props: ['guid','name','deeplink'],

        data() {
             return {
                  showModal:false,
                  days: 30,
                  graph_days: 30,
                  graph_months: 12,
                  graph_type: "daily",
                  graph_data_type: "deeplinkClicks",
                  message_text: "",
                  message_button_text: "",
                  message_button_link: "",
                  message_image_url: "",
                  message_background_color: "#5b73e8",
                  message_text_color: "#ffffff",
                  message_show: false,
                  dashboard_version: process.env.VUE_APP_VERSION,
                  showLoader: false,
                  matches: [],
                  modalData: {},
                  series: [
                    {
                      data: [0],
                    },
                  ],
                  orders_merchandising: [],
                  showOrdersStatistics: false,
                  options: {
                    chart: {
                      id: "vuechart-example",
                    },
                    xaxis: {
                      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
                    },
                  },

                  deeplinkSeries: [
                    {
                      name: "Merchandising",
                      type: "column",
                      data: [],
                    },
                    {
                      name: "Ewallet",
                      type: "area",
                      data: [],
                    },
                    {
                      name: "Ticketing",
                      type: "line",
                      data: [],
                    },
                  ],

                  deeplinkChartOptions: {
                    chart: {
                      width: "100%",
                      height: 390,
                      type: "bar",
                      stacked: false,
                      toolbar: {
                        show: false, //hide zoom in-out, export buttons
                      },
                    },
                    noData: {
                      text: "Loading...",
                      align: "center",
                      verticalAlign: "middle",
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: "14px",
                      },
                    },
                    stroke: {
                      width: [1, 2, 5],
                      curve: "smooth",
                    },
                    plotOptions: {
                      bar: {
                        columnWidth: "50%",
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },

                    fill: {
                      opacity: [0.85, 0.25, 1],
                      gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100],
                      },
                    },
                    colors: ["#5b73e8", "#e8e9eb", "#f1b54d"],
                    labels: [],
                    markers: {
                      size: 0,
                    },
                    xaxis: {
                      type: "text",
                    },

                    /*  yaxis: {
                          title: {
                            text: '',
                          },
                       //   min: 0
                        }, */

                    //2 yaxis
                    yaxis: [
                      {
                        title: {
                          text: "",
                        },
                      },
                      {
                        opposite: true,
                        title: {
                          text: "",
                        },
                      },
                    ],

                    tooltip: {
                      shared: true,
                      intersect: false,
                      y: {
                        formatter: function(y) {
                          if (typeof y !== "undefined") {
                            return y.toFixed(0) + "";
                          }
                          return y;
                        },
                      },
                    },
                    animations: {
                      enabled: true,
                      easing: "linear",
                      speed: 1500,
                      animateGradually: { enabled: true, delay: 1500 },
                      dynamicAnimation: { enabled: true, speed: 1500 },
                    },
                  },

                  growthChartOptions: {
                    fill: {
                      colors: ["#f1b44c"],
                    },
                    chart: {
                      type: "bar",
                      sparkline: {
                        enabled: true,
                      },
                    },
                    plotOptions: {
                      bar: {
                        columnWidth: "50%",
                      },
                    },
                    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                    xaxis: {
                      crosshairs: {
                        width: 1,
                      },
                    },
                    tooltip: {
                      fixed: {
                        enabled: false,
                      },
                      x: {
                        show: false,
                      },
                      y: {
                        title: {
                          formatter: function() {
                            return "";
                          },
                        },
                      },
                      marker: {
                        show: false,
                      },
                    },
                  },
                  orderseries: [70],
                  orderRadial: {
                    fill: {
                      colors: ["#34c38f"],
                    },
                    chart: {
                      sparkline: {
                        enabled: true,
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    plotOptions: {
                      radialBar: {
                        hollow: {
                          margin: 0,
                          size: "60%",
                        },
                        track: {
                          margin: 0,
                        },
                        dataLabels: {
                          show: false,
                        },
                      },
                    },
                  },
                };
        },

        methods: {
            resetModal() {
        this.transactionData = [];
        this.refundsData = [];
        this.amount = '';
        this.reason = '';
        this.submitted = false;
        this.submittedR = false;
        this.tryingToEdit = false;
        this.status_e = '';
        this.oldStatus = '';
        this.isLoading = false;
        this.isBusy = false;
    },


         async getDeeplinkStatistics() {
              this.showLoader = true;
              try {
                await Statistics.getDeeplinkStatistics(
                  this.graph_days,
                  this.graph_type,
                  this.guid,
                  {}
                )
                  .then((response) => {
                    this.updateDeeplinkChart(response.data.data);
                  })
                  .catch((error) => {
                    this.error = error.response.data.error
                      ? error.response.data.error
                      : "";
                    this.failedmsg(this.error);
                  })
                  .finally(() => {
                    this.showLoader = false;
                  });
              } catch (error) {
                //console.log(error)
              }
            },

         updateDeeplinkChart(data) {
              this.deeplinkSeries = data.data;
                this.deeplinkChartOptions = {
                 ...this.deeplinkChartOptions, // keep existing structure
                  labels: data.labels,
                  colors: ["#5b73e8", "#f1b54d"],
                  stroke: {
                    width: [1, 5],
                  },
                  fill: {
                    opacity: [0.85, 1],
                  },

                  yaxis: [
                        {
                          title: {
                            text: "",
                          },
                        },
                        {
                          opposite: true,
                          title: {
                            text: "",
                          },
                        },
                      ]
                };
            },

            refreshData() {
                this.$emit('onRefresh') //event from parent
            },
            closeModal() {
                this.showModal = false;
            },


          getGraphStatistics() {
            this.getDeeplinkStatistics(this.graph_days, "daily");
          },

        }
    };
</script>

<template>
    <b-modal @shown="resetModal(); getDeeplinkStatistics();" v-model="showModal" id="view_campaign" :title="'View Deeplink Campaign Details - ' + name" title-class="font-18" size="xl" centered>
    <div></div>


<template>
  <div class="row">



    <!--  <div class="row"> -->
    <div class="col-xl-8" :style="{ width: '100%;' }">
      <div class="card">
        <div class="card-body">
          <div class="col-sm-4 float-start">
            <template>
              <select
                v-model="graph_data_type"
                class="form-select"
                @change="getGraphStatistics()"
              >
                <option value="deeplinkClicks" selected
                  >Deeplink Clicks</option
                >
              </select>
            </template>
          </div>
          <div class="col-sm-2 float-end">
            <select
              v-model="graph_type"
              class="form-select"
              @change="getDeeplinkStatistics()"
            >
              <option value="daily" selected>Daily</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>
          <br />

          <div class="mt-3 p-2">
            <div
              class="card-body d-flex align-items-center justify-content-center"
              v-if="showLoader"
            >

            </div>
            <apexchart
              id="deeplinkChart"
              data-colors='["--bs-primary", "#dfe2e6", "--bs-warning"]'
              class="apex-charts"
              ref="deeplinkChart"
              :options="deeplinkChartOptions"
              :series="deeplinkSeries"
            >
            </apexchart>
          </div>
        </div>
        <!-- end card-body-->
      </div>
      <!-- end card-->
    </div>
    <!-- end col-->

    <div class="col-xl-4" v-if="message_show">
      <div
        class="card"
        :style="{ 'background-color': message_background_color }"
      >
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-sm-8">
              <p
                class="font-size-18"
                :style="{ color: message_text_color }"
                v-html="message_text"
              ></p>
              <div class="mt-4">
                <a
                  :href="this.message_button_link"
                  class="btn btn-success waves-effect waves-light"
                  >{{ this.message_button_text }}</a
                >
              </div>
            </div>
            <div class="col-sm-4">
              <div class="mt-4 mt-sm-0">
                <img :src="this.message_image_url" class="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- end card-body-->
      </div>
      <!-- end card-->
    </div>
    <!-- end col-->

  </div>
  <!-- end row-->
</template>


    </b-modal>
</template>